import type { PointOptionsObject } from "highcharts";
import type { Period } from "../hooks/usePeriod";
import { isInPeriod } from "../hooks/usePeriod";

export default function testSerieData(
  serie:
    | Highcharts.SeriesLineOptions
    | Highcharts.SeriesFlagsOptions
    | Highcharts.SeriesArearangeOptions
    | Highcharts.SeriesAreaOptions
    | Highcharts.SeriesScatterOptions,
  period: Period,
  test: (point: PointOptionsObject) => boolean,
) {
  if (serie.visible === false) return false;
  const data = serie.data as PointOptionsObject[];
  return data.filter(p => p.x !== undefined && isInPeriod(period, p.x)).some(test);
}
